// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1XRJD","cell":"ColumnAccessor_cell__2I95a","firstCellAccent":"ColumnAccessor_firstCellAccent__1Cvsg"};